const configEnvironment = String(
  import.meta.env.VITE_APP_CONFIG_ENVIRONMENT || "",
).toLowerCase();
const isProductionEnvironment = configEnvironment === "production";

export const OPEN_WORK_ORDER_LIMIT = isProductionEnvironment ? 2000 : 50;

export const shouldBlockPmeCreateForOpenLimit = (openCount, immediateCount) => {
  if (immediateCount <= 0) return false;
  return openCount + immediateCount > OPEN_WORK_ORDER_LIMIT;
};
